/* istanbul ignore file */
// TODO [LEARN-15811]: ^ ignore coverage on this file until we can have app test scaffolding ready
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { RouteContentGetter } from 'layers/content/v2/Hocs/RouteContentGetter'
import { navigationEvent } from 'layers/navigation/store/operations'
import withApiError from 'layers/errorHandling/apiError'
import { userSegmentationBuilder } from 'utils/userSegmentationHelpers'
import {
  AI_HS_PAGE_USAGE_KEY,
  sendApplicationInsightsEvent,
} from 'utils/sendAnalyticsDataHelpers'
import {
  resolveRouteServiceApp,
  isTier2PreviewMode,
  isDigitalWellBeingPreviewMode,
  isHighSchoolUrl,
  isK5Url,
  isMiddleSchoolUrl,
} from 'utils/routing/routeHelpers'
import { isPreviewMode } from 'utils/highschoolHelpers'
import { selectors as lmsSelectors } from 'store/lmsManager'
import { selectProgramUserContext } from 'utils/contextHelpers'

import Component from './component'

const IndividualResourceV2_5Container = props => {
  const {
    routeContent,
    userSegmentationInfo,
    navigationEvent,
    productTabTitle,
    instructorData,
    playerUserContext,
    match,
  } = props || {}

  const { content = {}, loading } = routeContent || {}
  const learningExperience = content?.learningExperience || null

  const readyToLoad = !loading && !!learningExperience

  useEffect(() => {
    sendApplicationInsightsEvent(AI_HS_PAGE_USAGE_KEY, userSegmentationInfo)
  }, [content, userSegmentationInfo])

  const isLessonPreview =
    isTier2PreviewMode() || isDigitalWellBeingPreviewMode()
  const isRoutePreview =
    String(match?.params?.verb || '').toLowerCase() === 'preview'
  const isHsPreview = isPreviewMode() && isHighSchoolUrl()
  const isPreview = isRoutePreview || isLessonPreview || isHsPreview

  return readyToLoad ? (
    <Component
      entry={learningExperience}
      gradeInstructorData={instructorData}
      isHsPreview={isHsPreview}
      isPreview={isPreview}
      match={match}
      navigationEvent={navigationEvent}
      playerUserContext={playerUserContext}
      productTabTitle={productTabTitle}
      routeContent={routeContent}
    />
  ) : null
}

IndividualResourceV2_5Container.propTypes = {
  instructorData: PropTypes.object,
  playerUserContext: PropTypes.object,
  routeContent: PropTypes.shape({
    content: PropTypes.shape({
      learningExperience: PropTypes.object,
    }),
    loading: PropTypes.bool,
  }),
  userSegmentationInfo: PropTypes.object,
}

const mapStateToProps = state => {
  let instructorData = null
  if (isHighSchoolUrl()) {
    instructorData = lmsSelectors.selectHsInstructorData(state)
  } else if (isMiddleSchoolUrl()) {
    instructorData = lmsSelectors.selectMiddleSchoolInstructorData(state)
  } else if (isK5Url()) {
    instructorData = lmsSelectors.selectk5InstructorData(state)
  }

  return {
    userSegmentationInfo: userSegmentationBuilder(state),
    productTabTitle: state.productManager?.productMap?.name || '',
    instructorData,
    playerUserContext: selectProgramUserContext(state),
  }
}

const mapDispatchToProps = {
  navigationEvent,
}

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: () => window?.location?.pathname,
}

const HydratedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(IndividualResourceV2_5Container)

export default RouteContentGetter(withApiError(HydratedComponent), options)
